import React from "react";
import { Modal, Text, Stack, Group, Button, List } from "@mantine/core";
import { useResponsive } from "../../context/ResponsiveContext";
import { brandColors } from "../../theme/brandTheme";
import styles from "./UpdateStaffServicesModal.module.css";

interface UpdateStaffServicesModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: (option: "staff_without_customization" | "all_staff") => void;
  changedFields: string[];
}

export default function UpdateStaffServicesModal({
  opened,
  onClose,
  onConfirm,
  changedFields,
}: UpdateStaffServicesModalProps) {
  const { isMobile } = useResponsive();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Update staff services?"
      size="md"
      fullScreen={isMobile}
      centered
      transitionProps={{ duration: 0 }}
    >
      <Stack gap="md">
        <Text size="sm">
          You've updated the following fields for this service:
        </Text>

        <List size="sm" spacing="xs" className={styles.fieldList}>
          {changedFields.map((field, index) => (
            <List.Item key={index}>{field}</List.Item>
          ))}
        </List>

        <Text size="sm" mt="md">
          Would you like to apply these changes to your all staff or only staff
          without customization?
        </Text>

        <Group
          gap="md"
          mt="xl"
          justify="flex-end"
          className={styles.buttonGroup}
        >
          <Button
            variant="outline"
            onClick={() => onConfirm("staff_without_customization")}
            className={styles.staffWithoutButton}
          >
            Staff without customization
          </Button>
          <Button
            onClick={() => onConfirm("all_staff")}
            className={styles.allStaffButton}
            styles={{
              root: {
                backgroundColor: brandColors.teal,
                color: "white",
                "&:hover": {
                  backgroundColor: brandColors.teal,
                },
              },
            }}
          >
            All staff
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
